module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Wettingen-b21b1b226574abe39cc01e8f193881fc.svg";